<template>
    <v-dialog
        v-model="showDialog"
        :width="displayWidth"
        persistent
        eager
        @keydown.esc="onEscapeKeydown"
    >
        <v-card
            ref="dialogCard"
            role="region"
            aria-label="user-profile-select-dialog"
        >
            <v-card-title class="px-4">
                <div>Add new user</div>
            </v-card-title>
            <v-card-text class="px-5 py-0">
                <v-container fluid pa-0>
                    <v-row no-gutters>
                        <v-col>
                            <span class="text-subtitle-1">
                                Please selected a user profile type
                            </span>
                            <v-radio-group v-model="selectedType">
                                <v-radio
                                    v-for="(item, index) in profileTypes"
                                    :key="`profile-type-${index}`"
                                    :label="item.text"
                                    :value="item.value"
                                ></v-radio>
                            </v-radio-group>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-card-actions class="justify-end">
                <v-btn outlined small @click="onCancelClick">Cancel</v-btn>
                <v-btn small color="primary" @click="onConfirmClick"
                    >Add User</v-btn
                >
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'ProfileSelect',
    props: {
        showDialog: {
            type: Boolean,
            required: true,
            default: false
        }
    },
    data() {
        return {
            profileTypes: [
                { text: 'Venue user', value: 'VENUE_USER' },
                { text: 'Venue admin', value: 'VENUE_ADMIN' },
                { text: 'Blank profile', value: 'BLANK' }
            ],
            selectedType: 'VENUE_USER'
        };
    },
    computed: {
        displayWidth() {
            if (this.$vuetify.breakpoint.mdAndUp) {
                return '450px';
            }
            return '95%';
        }
    },
    methods: {
        onCancelClick() {
            this.selectedType = null;
            this.closeThisDialog();
        },
        onConfirmClick() {
            this.closeThisDialog();
        },
        onEscapeKeydown() {
            if (this.showCloseButton) {
                this.onCloseClick();
            } else if (this.showCancelButton) {
                this.onCancelClick();
            }
        },
        closeThisDialog(timeout = 500) {
            setTimeout(() => {
                this.$emit('close', this.selectedType);
                this.resetDialogData();
            }, timeout);
        },
        resetDialogData() {
            this.selectedType = 'VENUE_USER';
        }
    }
};
</script>

<style></style>
